import { Component, Vue } from 'vue-property-decorator'
import { getMarketCooperationStatisticalData } from '@/api/common'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";
import {menuBtn} from "@/utils/menu_level2_button";
import * as echarts from 'echarts';
import * as math from "mathjs";

@Component({})
export default class CooperationStatisticsData extends Vue {
    loading = false
    dataFilter = 0
    page1 = 1
    page2 = 1
    page3 = 1
    total1 = 0
    total2 = 0
    total3 = 0
    data: any = []
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeType = '1'
    timeStr = ''
    resultList = []
    indexOne = 0

    buttonShow = menuBtn

    created() {
        this.getDateInterval()
    }


    getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (column.property != 'name' && column.property != 'proportion'&& column.property != 'averageCost') {
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return math.number(math.add(math.bignumber(prev), math.bignumber(curr)));
                        } else {
                            return prev;
                        }
                    }, 0)
                }
            } else if (column.property == 'proportion') {
                // 总产品占比（金额占比）计算公式
                // proportion = 总计项目售价 === 0 ? 0 : Math.round(总计订单金额 / 总计项目售价 * 100.00) / 100
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                      // 总计订单金额
                    sum1 = math.number(math.add(math.bignumber(sum1), math.bignumber(Number(item.financeOrderPriceSum))))
                      // 总计项目售价
                    sum2 = math.number(math.add(math.bignumber(sum1), math.bignumber(Number(item.souCoursePriceSum))))
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = Math.round(sum1 / sum2 * 100) / 100
                    sums[index] = finalVal
                } else {
                    sums[index] = Number(0)
                }
            }else if(column.property == 'averageCost'){
                // 总产品占比（金额占比）计算公式
                // proportion = 总计项目售价 === 0 ? 0 : Math.round(总计订单金额 / 总计项目售价 * 100.00) / 100
                let sum1 = 0
                let sum2 = 0
                data.forEach(item => {
                      // 总计订单金额
                    sum1 = math.number(math.add(math.bignumber(sum1), math.bignumber(Number(item.financeOrderPriceSum))))
                      // 总计项目售价
                    sum2 = math.number(math.add(math.bignumber(sum1), math.bignumber(Number(item.souCoursePriceSum))))
                })
                let finalVal = 0

                if (sum1 !== 0 && sum2 !== 0) {
                    finalVal = math.number(math.subtract(math.bignumber(1), math.bignumber(Math.round(sum1 / sum2 * 100) / 100)));
                    sums[index] = finalVal
                } else {
                    sums[index] = 1 - Number(0)
                }
            }
        })
        return sums;
    }

    async getData() {
        this.loading = true
        const obj = {
            timeStr: this.timeStr
        }
        const data: any = await getMarketCooperationStatisticalData(obj)
        this.data = data
        this.resultList = data.resultList
        this.initBarChartVisit(data.marketCooperationVisitCount)
        setTimeout(() => {
            this.loading = false
        }, 2000);
    }

    // 顾问拜访频次统计图
    initBarChartVisit(array){

        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '顾问拜访频次': item.count, }))
        } else {
            data = [{ 'product': '顾问姓名', '顾问拜访频次': 0 }]
        }

        const chartDom = document.getElementById('BarChartVisit');
        const myChart = echarts.init(chartDom);

        const option = {
            title: {
                subtext: '顾问拜访频次'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '顾问拜访频次'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '顾问姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        const str = value.split("");
                        return str.join("\n");
                    }

                }
            },
            yAxis: [
                { type: 'value' }
            ],

            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },

                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                }

            ]
        }

        option && myChart.setOption(option);

    }

    /*渠道送生同比*/
    openChanelRate() {
        window.open(window.location.origin + this.$route.matched[0].path + '/chanelGiveStudentRate')
    }

    changeRadio(val: number) {
        this.dataFilter = val
        this.getData()
    }
    changePage1(page1: number){
        this.page1 = page1
    }
    changePage2(page2: number){
        this.page2 = page2
    }
    changePage3(page3: number){
        this.page3 = page3
        this.getData()
    }

    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

    }
    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today,this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const  week = [this.startWeek,this.endWeek]
        const  month = [this.startMonth,this.endMonth]
        const  year = [this.startYear,this.endYear]
        const  quarter = [this.startQuarter,this.endQuarter]
        const  lastWeek = [this.startLastWeek,this.endLastWeek]
        const  lastMonth = [this.startLastMonth,this.endLastMonth]
        const  lastQuarter = [this.startLastQuarter,this.endLastQuarter]
        const  lastyear = [this.yesteryearStart,this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        }  else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        }else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }

}
